import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderDetailsPdfService } from './order-details-pdf.service';
import { FlightDetailsPdfService } from './flight-details-pdf.service';
import { BundledFarePdfService } from './bundled-fare-pdf.service';
import { ShoppingCartPdfService } from './shopping-cart-pdf.service';
import { PassengerDetailsPdfService } from './passenger-details-pdf.service';
import { MainbookerDetailsPdfService } from './mainbooker-details-pdf.service';
import { PdfSettings } from './pdf-settings';
import { Content } from 'pdfmake/interfaces';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
import { Order } from '@pages/common-order/_interfaces_/order.interface';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(
    private translateService: TranslateService,
    private orderDetailsPdfService: OrderDetailsPdfService,
    private flightDetailsPdfService: FlightDetailsPdfService,
    private bundledFarePdfService: BundledFarePdfService,
    private shoppingCartPdfService: ShoppingCartPdfService,
    private passengerDetailsPdfService: PassengerDetailsPdfService,
    private mainbookerDetailsPdfService: MainbookerDetailsPdfService
  ) {}

  public generatePdf(order: Order): void {
    const passengers = order?.flightBookings?.flatMap((flightBooking) => flightBooking.passengers) || [];
    this.createPdfDocument([
      this.orderDetailsPdfService.getContent(order.orderDetails),
      this.flightDetailsPdfService.getContent(order.flightBookings),
      this.bundledFarePdfService.getContent(order.flightBookings),
      this.shoppingCartPdfService.getContent(order.orderDetails.status, order.shoppingCart),
      this.passengerDetailsPdfService.getContent(passengers),
      this.mainbookerDetailsPdfService.getContent(order.booker),
    ]);
  }

  private createPdfDocument(content: Content): void {
    const documentDefinition = {
      info: { title: this.translateService.instant('PRINT.CONFIRMATION') },
      content,
      pageMargins: PdfSettings.pageMargins,
      defaultStyle: PdfSettings.defaultStyle,
      styles: PdfSettings.styles,
    };
    pdfMake.createPdf(documentDefinition).open();
  }
}
